import React from "react";
import { connect } from "react-redux";
import Breadcrumbs from "marketing/components/breadcrumbs";
import HeaderText from "header/components/title";

const mapStateToProps = ({ header, user }) => {
  const exploringCreatives = header.content === "explore_creatives";
  const userType = user.profile_data
    ? user.profile_data.user_type
    : "anonymous";
  const creativesHeader =
    userType === "creative"
      ? "Meet your fellow creatives."
      : "Meet the world's largest creative team.";
  const showStartProject = user.logged_in === false || userType === "client";
  const cta = showStartProject
    ? { url: "/start-a-project/", label: "Get started" }
    : null;
  const preTitle = (
    <Breadcrumbs
      items={[
        {
          title: "Explore " + (exploringCreatives ? "creatives" : "projects"),
          url: "/explore/" + (exploringCreatives ? "creatives/" : ""),
        },
      ]}
    />
  );
  const subTitle = exploringCreatives
    ? ""
    : "Explore projects just like yours that feature real human design and creativity.";

  return {
    title: exploringCreatives
      ? creativesHeader
      : "Thousands of projects. Zero robots.",
    isTitleMain: true,
    cta,
    preTitle,
    subTitle,
  };
};

export default connect(mapStateToProps)(HeaderText);
